import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[title-tmp]',
  standalone: false,
})
export class TitleTemplateDirective {
  constructor(public template: TemplateRef<any>) {}
}
